const React = require('react');
const AjaxFunctions = require('./ajaxFunctions.js');
const Utils = require('./utils.js');
const SharedModels = require('../../../shared/sharedModels');
const ReduxStore = require('./redux/reduxStore.jsx.js');
const Link = require('react-router-dom').Link;
const AsterPlot = require('./components/asterPlot.jsx').AsterPlot;
const moment = require('moment');
import ReactTooltip from 'react-tooltip'
import UserDetails from './components/userDetails.jsx';

import Toastr from "toastr";
import { Grid, Typography, Chip, Tabs, Tab } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoadingScreen } from './components/loadingScreen.jsx.js';
import ReactLinkify from 'react-linkify';

function formatActivityData(rawData){
   let formattedArray = {
      cards: [],
      comments: [],
   };
   for(let entry of rawData){
      if(entry.type === 'cardComment'){
         formattedArray.comments.push(entry);
      }
      else{
         formattedArray.cards.push(entry);
      }
   }

   return formattedArray;
}

export class UserProfile extends React.Component{
   constructor(props) {
      super(props);

      this.state = {
         userActivityData: {
            cards: [],
            comments: [],
         },
         followingActivityData: {
            cards: [],
            comments: [],
         },
         followerActivityData: {
            cards: [],
            comments: [],
         },
         followingData: {
            cards: [],
            comments: [],
         },
         followerData: {
            cards: [],
            comments: [],
         },
         upvoteActivityData: {
            cards: [],
            comments: [],
         },
         user: new SharedModels.User({}),
         currentFeedIndex: 'following',
         isCurrentUserProfile: 0,
         isCurrentUserFollowing: 0,
         topicData: [],
         pointGroupData: [],
         isInitialized: false
      };
   }

   setCurrentFeedIndex(index) {
      this.setState({currentFeedIndex: index})
   }

   componentDidMount() {
      let idUser = Utils.getParameterByName('idUser', window.location.href) || window.globals.idUser;

      Promise.all([
         AjaxFunctions.getProfileData(idUser),
         AjaxFunctions.getUserTopicCount(idUser),
         AjaxFunctions.getUpvoteActivityForUserByID(idUser),
         AjaxFunctions.getUserPointAwardGroupCount(idUser),
      ]).then((data) => {
         let userActivityData = formatActivityData(data[0].userActivityData);
         let followerActivityData = formatActivityData(data[0].followerActivityData);
         let followingActivityData = formatActivityData(data[0].followingActivityData);
         let followerData = formatActivityData(data[0].followerData);
         let followingData = formatActivityData(data[0].followingData);
         this.setState({
            userActivityData,
            followingActivityData,
            followerActivityData,
            followingData,
            followerData,
            user: data[0].userData,
            isCurrentUserProfile: data[0].isCurrentUserProfile,
            isCurrentUserFollowing: data[0].isCurrentUserFollowing,
            topicData: data[1],
            upvoteActivityData: data[2],
            pointGroupData: data[3],
            isInitialized: true
         });

         ReduxStore.store.dispatch(ReduxStore.UserFunctions.setTargetUser(data[0].userData, data[0].isCurrentUserFollowing));

      }, (err) => {
         Toastr.options.positionClass = 'toast-bottom-full-width';
         Toastr.error(err);
      });
   }


   render() {
      const { currentFeedIndex } = this.state;
      
      if(!this.state.isInitialized){
         return(<LoadingScreen/>)
      }
      
      let { cards = [], comments = [] } = this.state[`${currentFeedIndex}Data`];
      return(
         <Grid container justify='center' spacing={2} >
            <Grid item lg={3}>
               <UserDetails showActionButtons={true} showName={false}/>
            </Grid>
            <Grid item lg={9}>
            <div>
            <div>
            <Typography style={{ fontWeight: '400', fontSize: '35px',marginBottom:'10px'}}>
               {this.state.user.firstName ? `${this.state.user.firstName} ${this.state.user.lastName}`: ''}
               </Typography>
               <div style={{marginBottom:10}}>
               {this.state.user.location && <Chip icon={ <FontAwesomeIcon icon={['fas',"location"]} size={'lg'} /> } label={this.state.user.location} style={{marginRight:5, marginBottom:10}}></Chip>}
               {this.state.user.affiliation && <Chip label={this.state.user.affiliation} style={{marginRight:5, marginBottom:10}}></Chip>}
               {this.state.user.link && <ReactLinkify><Chip clickable onClick={() => window.open(this.state.user.link, '_blank')} icon={<FontAwesomeIcon icon={['fas',"link"]} size={'lg'} /> } label={this.state.user.link} style={{marginRight:5, marginBottom:10}}></Chip></ReactLinkify>}
               {this.state.user.orcidID && <ReactLinkify><Chip clickable onClick={() => window.open(`https://orcid.org/${this.state.user.orcidID}`, '_blank')} icon={<FontAwesomeIcon icon={['fab',"orcid"]} size={'lg'} /> } label={this.state.user.orcidID} style={{marginRight:5, marginBottom:10}}></Chip></ReactLinkify>}
               <br/>
               {this.state.user.bio && <Chip
                  label={<Typography style={{whiteSpace: 'normal', fontSize: '14px'}}>{this.state.user.bio}</Typography>}
                  style={{height:"100%", marginRight: 5, marginBottom: 10}}
               />}
               </div>
            </div>
            <div className='row no-gutters' style={{ width: '100%'}}>
            <div style={{ marginLeft: '2em',  marginRight: '5em', marginTop: '2em' }}>
               <AsterPlot chartData={this.state.topicData} width="300" height="300" />
               {this.state.topicData.length > 0 && <div style={{ color: 'grey', textAlign: 'center' }}>
                  <h1>Evidence Created</h1>
                  <h3>Evidence topics across multiple disciplines</h3>
               </div>}
            </div>
            <div style={{ marginLeft: '2em', marginTop: '2em' }}>
               <AsterPlot chartData={this.state.pointGroupData} width="300" height="300" />
               {this.state.pointGroupData.length > 0 &&
                  <div style={{ color: 'grey', textAlign: 'center' }}>
                     <h1>Point Awards</h1>
                     <h3>Scoring activities that build the community</h3>
                  </div>}
            </div>
            <UserFeed
               rowItems={cards}
               comments={comments}
               currentFeedIndex={currentFeedIndex}
               setCurTab={(tab) => this.setCurrentFeedIndex(tab)}
            />
         </div>
         </div>
            </Grid>
         </Grid>
      );
   }
};

function UserFeed(props) {
   const { rowItems, currentFeedIndex, setCurTab } = props;
   const tabContent = rowItems.map(rowItem => {
      if(rowItem.username || rowItem.email){
         return(
            <UserRow key={`${currentFeedIndex}_${rowItem.idUser}`} user={rowItem}/>
         )
      }
      else if (rowItem.idUpvote) {
         return (
            <UserFeedUpvoteRow key={`${currentFeedIndex}_${rowItem.idUpvote}`} card={rowItem}/>
         )
      }
      else {
         return (
            <UserFeedCardRow key={`${currentFeedIndex}_${rowItem.id}`} card={rowItem}/>
         )
      }
   });

   return (
      <div className='col-12'>
         <div className='user-feed mt-5 ml-4'>
            <Tabs
               className='userfeed-tabs'
               value={currentFeedIndex}
               onChange={(event, value) => setCurTab(value)}
               indicatorColor="primary"
               textColor="primary"
            >
               <Tab className='portfolio-list-page-tab-header material-button' value='following' label='Following' />
               <Tab className='portfolio-list-page-tab-header material-button' value='follower' label='Followers' />
               <Tab className='portfolio-list-page-tab-header material-button' value='userActivity' label='My Published Pubs' />
               <Tab className='portfolio-list-page-tab-header material-button' value='upvoteActivity' label='My Compliment Activity' />
               <Tab className='portfolio-list-page-tab-header material-button' value='followingActivity' label='Following Activity' />
               <Tab className='portfolio-list-page-tab-header material-button' value='followerActivity' label='Follower Activity' />
            </Tabs>
            <div className='container pub-cards'>
               {tabContent}
            </div>
         </div>
      </div>
   );
}

function UserFeedUpvoteRow(props) {
   const { card } = props;
   let rowColor = '#0BBDD1';
   let linkBase = 'evidenceCard';
   let cardTypeText = 'your Evidence';
   if(card.type === 'reasoningCard'){
      rowColor = '#66769A';
      linkBase = 'reasoningCard';
      cardTypeText = 'your Conjecture';
   }
   let name = '';
   let idCreator = 0;
   if(card.cardCreatorId){
      name = card.creatorFirstName + ' ' + card.creatorLastName + ' ';
      idCreator = card.idUpvoteCreator;
   }
   return (
      <div className='row user-feed-card-row'>
         <div className='col col-md-12' style={{borderLeft: '10px solid ' + rowColor}}>
            <Link to={'/users/profile?idUser=' + idCreator}>{name}</Link>
            complimented {cardTypeText} &micro;Pub "
            <a href={'/' + linkBase + '?idCard=' + card.idCard} style={{color: rowColor}}>
               {card.cardTitle}
            </a>
            " on {new Date(card.upvoteCreationTime).toLocaleDateString()}
         </div>
      </div>
   );
}

function UserFeedCardRow(props) {
   const { card } = props;
   let rowColor = '#0BBDD1';
   let linkBase = 'evidenceCard';
   let cardTypeText = 'an Evidence';
   if(card.type === 'reasoningCard'){
      rowColor = '#66769A';
      linkBase = 'reasoningCard';
      cardTypeText = 'a Conjecture';
   }
   if(card.type === 'stimulusCard'){
      rowColor = '#4357CF';
      linkBase = 'stimulusCard';
      cardTypeText = 'a Stimulus';
   }
   let name = '';
   let idCreator = 0;
   if(card.creator){
      name = card.creator.firstName + ' ' + card.creator.lastName + ' ';
      idCreator = card.creator.id;
   }
   return (
      <div className='row user-feed-card-row'>
         <div className='col col-md-12' style={{borderLeft: '10px solid ' + rowColor}}>
            <Link to={'/users/profile?idUser=' + idCreator}>{name}</Link>
            Created {cardTypeText} &micro;Pub "
            <a href={'/' + linkBase + '?idCard=' + card.id} style={{color: rowColor}}>
               {card.text}
            </a>
            " on {new Date(card.creationTime).toLocaleDateString()}
         </div>
      </div>
   );
}

function UserRow(props) {
   const { user } = props;
   let loggedIn = (user.lastLoginTime)? moment(new Date()).diff(moment(new Date(user.lastLoginTime)), 'minutes'):null;
   // If the user logged in recently, the circle next to the user will appear green. 
   // Regardless of time, if the user has a last login time, it will be displayed in the toooltip.
   let loggedInRecently = loggedIn!=null && loggedIn < 10;
   let circleStyle = { height: '15px', width: '15px', backgroundColor: `${(loggedInRecently) ? "#56a97a" : "#bdbdbd"}`, borderRadius: '50%', marginRight: '10px', marginTop: '5px' };
   let circle = <span data-tip={`${user.lastLoginTime ? `Last Active: ${moment(user.lastLoginTime).calendar()}` : "Not Recently Active"}`} data-for={user.idUser + ""} style={circleStyle}></span> 
   return (
      <div className='row user-feed-card-row'>
         <ReactTooltip id={user.idUser+""} place="left"/>
         {circle}
         <Link to={'/users/profile?idUser=' + user.idUser}>
            {`${user.firstName} ${user.lastName}, Level ${Utils.calculateUserLevel(user.points)} (${user.points} points) `}
         </Link>
      </div>
   );
}

class UserFeedCommentRow extends React.Component{
   constructor(props) {
      super(props);
   }

   render() {
      return (
         <div className='row user-feed-card-row'>
            Left a comment "{comment.text}" on {new Date(comment.creationTime).toLocaleDateString()}
         </div>
      );
   }
}
